export default function AppSkeleton() {
  return (
    <div className="fixed inset-0 bg-gray-50 flex overflow-hidden z-50">
      {/* Sidebar Skeleton */}
      <div className="w-[280px] bg-white border-r border-gray-200 p-6 hidden lg:flex flex-col">
        <div className="space-y-6">
          {/* Logo/Title */}
          <div className="h-10 bg-gray-200 rounded-2xl animate-pulse w-3/4 mb-8"></div>

          {/* Menu Items */}
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="flex items-center gap-4 py-2">
              <div className="w-5 h-5 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-5 bg-gray-200 rounded-lg animate-pulse flex-1"></div>
            </div>
          ))}

          {/* Bottom section */}
          <div className="mt-auto pt-8 border-t border-gray-200">
            <div className="flex items-center gap-4 py-2">
              <div className="w-5 h-5 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-5 bg-gray-200 rounded-lg animate-pulse flex-1"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className="w-[280px] bg-white border-r border-gray-200 p-6 flex flex-col lg:hidden">
        <div className="space-y-6">
          <div className="h-10 bg-gray-200 rounded-2xl animate-pulse w-3/4 mb-8"></div>
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="flex items-center gap-4 py-2">
              <div className="w-5 h-5 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-5 bg-gray-200 rounded-lg animate-pulse flex-1"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Navbar Skeleton */}
        <div className="bg-white border-b border-gray-200 px-6 py-4 flex-shrink-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              {/* Mobile menu button skeleton */}
              <div className="w-8 h-8 bg-gray-200 rounded-lg animate-pulse lg:hidden"></div>
              <div className="h-6 bg-gray-200 rounded-lg animate-pulse w-48"></div>
            </div>
            <div className="flex items-center gap-4">
              {/* Search */}
              <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse hidden md:block"></div>
              {/* Notifications */}
              <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse"></div>
              {/* Profile */}
              <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Content Skeleton */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-8">
              <div className="h-10 bg-gray-200 rounded-2xl animate-pulse w-64 mb-3"></div>
              <div className="h-6 bg-gray-200 rounded-xl animate-pulse w-96"></div>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="bg-white rounded-3xl p-6 shadow-lg">
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 bg-gray-200 rounded-2xl animate-pulse"></div>
                    <div className="w-16 h-4 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                  <div className="w-24 h-8 bg-gray-200 rounded mb-2 animate-pulse"></div>
                  <div className="w-32 h-4 bg-gray-200 rounded animate-pulse"></div>
                </div>
              ))}
            </div>

            {/* Quick Actions */}
            <div>
              <div className="h-8 bg-gray-200 rounded-xl animate-pulse w-48 mb-6"></div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {Array.from({ length: 3 }).map((_, i) => (
                  <div key={i} className="bg-white rounded-3xl p-6 shadow-lg">
                    <div className="w-12 h-12 bg-gray-200 rounded-2xl mb-4 animate-pulse"></div>
                    <div className="h-6 bg-gray-200 rounded mb-2 animate-pulse w-3/4"></div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
